import React from 'react';
import styles from './QuoteAndPhoto.module.scss';

const QuoteAndPhoto = ({ text, caption, photo }) => {
  return ( 
    <section className={ styles.QuoteAndPhoto }>
      <div className={ styles.content }>
        <article>
          <Quote { ...caption } text={ text } />
        </article>
        <figure>
          <img src={ photo } alt={ caption.name }
            width="385"
          />
        </figure>
      </div>
    </section>
  );
};

const Quote = ({ text, name, position }) => {
  return ( 
    <div className={ styles.Quote }>      
      <blockquote className={ styles.text }>&#8220;{ text }&#8221;</blockquote>
      <p className={ styles.signature }><b>{ name }</b>, { position }</p>
    </div>  
  );
};

export default QuoteAndPhoto;
